<template>
  <div
    class="autocomplete cases-checklist"
    v-click-outside-cases="onOutsideClick"
  >
    <!-- Input with validation-->
    <div
      v-if="validateProp"
      class="input-wrapper input-field"
      :class="{'error-input' : (errors.has(name) && validateField)}"
    >
      <input
        type="text"
        :placeholder="placeholder"
        class="input"
        :class="name"
        v-model="search"
        @input="onChange"
        @click="onClick"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        @focus.self="clearInputErrors"
        @blur="clearOthers"
        @keydown.tab="onTabClick"
        :name="name"
        v-validate="'required'"
        readonly="readonly"
        autocomplete="off" />
      <span class="icon-wrapper" :class="name" @click="onClickArrow">
        <img class="icon" :class="name" src='@/assets/images/arrow_down.png' />
      </span>
      <img src="@/assets/images/validation_ico.png" alt="" class="icon error-icon" :class="name">
      <div
        v-show="(errors.has(name))"
        :class="{'hide-tooltip' : bluredProp !== name}"
        class="error-tooltip"
      >
        <div class="text">
          {{ errors.first(name) }}
        </div>
      </div>
    </div>
    <!-- Input with no validation-->
    <div
      v-if="!validateProp"
      class="input-wrapper input-field"
    >
      <input
        type="text"
        :placeholder="placeholder"
        class="input"
        v-model="search"
        @input="onChange"
        @click="onClick"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        @keydown.tab="onTabClick"
        :name="name"
        readonly="readonly"
        autocomplete="off" />
      <span class="icon-wrapper" @click="onClickArrow">
        <img class="icon"  src='@/assets/images/arrow_down.png' />
      </span>
    </div>
    <ul
      v-show="isOpen"
      class="autocomplete-results"
      :class="name"
      ref="scrollContainer"
    >
      <li
        v-for="(result, indexResults) in results"
        :key="`casesResults-${indexResults}`"
        class="autocomplete-result"
        :class="{ 'is-active': indexResults === arrowCounter, 'italics': result === 'No entry found' }"
      >
        <div
          v-if="result.children != null"
          class="result-label-wrapper"
          :class="name"
        >
          <div
            class="result-label"
            :class="{'disabled' : disableNeededProp ? result.disabled : false, name}"
          >
            <span>{{ result.shortenedName }}</span>
          </div>
            <label
              v-for="(child, indexResChild) in result.children"
              :key="`casesChildResults-${indexResChild}`"
              class="checkbox-wrapper"
              :class="{'disabled' : disableNeededProp ? child.disabled : false, name, 'is-active': indexResChild === arrowCounter}"
              ref="options"
            >
              {{ child.name }}
              <input
                type="checkbox"
                class="checkbox-input"
                :class="name"
                v-model="child.clicked"
                @click="setResult(child)"
                :disabled="disableNeededProp ? child.disabled : false"
              >
              <span class="checkmark" :class="name"></span>
            </label>
        </div>
        <div v-if="result.children == null">{{ result }} </div>
      </li>
    </ul>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'

export default {
  name: "casesChecklist",
  inject: ['$validator'],
  directives: {
      clickOutsideCases: vClickOutside.directive
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    placeholder: {
      type: String,
      required: false,
      default: () => ""
    },
    option: {
      type: Boolean,
      required: false,
      default: () => false
    },
    name: {
      type: String,
      required: false,
      default: () => ""
    },
    bluredProp: {
      type: String,
      required: false,
      default: () => ''
    },
    validateProp: {
      type: Boolean,
      required: false,
      default: () => true
    },
    filterNoDisable: {
      type: Boolean,
      required: false
    },
    disableNeededProp: {
      type: Boolean,
      required: false,
      default: () => true
    }
  },
  data() {
    return {
      newChildrenForInput: [],
      search: "",
      results: [],
      isOpen: false,
      isLoading: false,
      arrowCounter: -1,
      validateField: false
    };
  },
  watch: {
    option: function(val) {
      if (val) {
        this.setOption()
      }
    }
  },
  mounted() {
    this.$validator.resume();
    this.setOption()
  },
  destroyed() {
    this.$validator.pause();
  },
  methods: {
    onClick(e) {
      this.setValidateField();
      this.isOpen = true;
      this.results = this.items;
      this.disableCases();
      this.$emit("clearInputErrors", e);
    },
    onClickArrow() {
      this.setValidateField();
      this.isOpen = !this.isOpen;
      this.results = this.items;
      this.disableCases()
    },
    onChange() {
      this.optionChanged()
    },
    /**
     *
     * @description Inject or remove the children from the input field
     * @param {Object} result
     * @return {String}
     */
    setResult(result) {
      // Track the index of currently selected element in dropdown
      let indexElem;
      // Reset status clicked to false to have default state
      result.clicked = !result.clicked;
      // Remove any errors associate with Children input
      this.$validator.errors.remove(this.name);

      // Find the index of currently clicked element in dropdown
      this.newChildrenForInput.forEach((elem, i) => {
        if (elem.childGuid === result.childGuid) {
          indexElem = i
        }
      });

      // On currently clicked element - add it to the array
      if (result.clicked) {
        this.newChildrenForInput.push(result)
      }
      // When we click on the same element, delete it from the array
      else {
        this.newChildrenForInput.splice(indexElem,1)
      }

      // Print the value to the input field when we have ONLY 1 element
      if (this.newChildrenForInput.length === 1) {
        this.search = this.newChildrenForInput[0].name
      }
      // Print the value to the input field when we have MORE than 1 element
      else if (this.newChildrenForInput.length > 1) {
        // Reset the input field to default
        this.search = '';
        // Recalculate the input field
        this.newChildrenForInput.forEach(child => {
          this.search = `${this.search}${child.name}, `;
        });
        // Remove the trailing comma at the end of the string
        this.search = this.search.substring(0, this.search.length - 2);
      }
      // Reset the input field to default
      else {
        this.search = ''
      }

      this.isOpen = true;
      // Emit the input value to components
      this.optionChanged();
      // Upon setting the input field, disable cases from other co-parents
      this.disableCases()
    },
    disableCases() {
      // On transaction history endpoint we sent a prop "filterNoDisable", which is always true,
      // because we don't won't to disable filter sections for all childrens
      if (this.filterNoDisable) {
        return
      }
      let clickedCase = this.results.filter(caseIt => caseIt.children.some(child => child.clicked))[0];

      if (clickedCase) {
        let casesToBeDisabled = this.results.filter(caseIt => caseIt.caseGuid !== clickedCase.caseGuid);
        casesToBeDisabled.forEach(caseIt => {
          caseIt.disabled = true;
          let caseChildren = caseIt.children;
          caseChildren.forEach(child => child.disabled = true);
          caseIt.children = caseChildren
        });

        let clickedCaseIndex = this.results.indexOf(clickedCase);
        let newCases = casesToBeDisabled.map(caseIt => caseIt);
        newCases.splice(clickedCaseIndex, 0, clickedCase);
        this.results = newCases
      } else {
        this.results.forEach(caseIt => {
          caseIt.disabled = false;
          const caseChildren = caseIt.children;
          caseChildren.forEach(child => child.disabled = false);
            caseIt.children = caseChildren
        })
      }
    },
    onArrowDown() {
      let allChildren = []
      this.results.forEach(result => {
        result.children.forEach(child => {
          allChildren.push(child)
        })
      });
      if (this.arrowCounter < allChildren.length) {
        this.arrowCounter = this.arrowCounter + 1;
        this.fixScrolling();
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
        this.fixScrolling();
      }
    },
    fixScrolling(){
      if(this.$refs.options[this.arrowCounter]) {
        const liH = this.$refs.options[this.arrowCounter].clientHeight;
        this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter + 10;
      }
    },
    onTabClick(e) {
      if (!this.isOpen) {
        this.onClick(e);
      } else {
        this.isOpen = false;
        this.arrowCounter = -1;
        e.target.blur();
      }
    },
    onEnter() {
      this.search = this.results[this.arrowCounter];
    },
    optionChanged() {
      this.$emit("optionChanged", this.results);
      this.$validator.errors.remove(this.name);
    },
    clear() {
      this.search = ''
    },
    clearInputErrors(e) {
      this.onClick(e);
      this.$emit("clearInputErrors", e);
    },
    clearOthers(e) {
      this.$emit("clearOthers", e);
    },
    onOutsideClick() {
      if (this.isOpen) {
        this.isOpen = false;
        this.arrowCounter = -1;
        if (this.validateProp) {
          if (this.search === '') {
            this.createError()
          } else {
            this.$validator.errors.remove(this.name)
          }
        }
      }
    },
    setValidateField() {
      this.validateField = true
    },
    createError() {
      if (!this.$validator.errors.has(this.name)) {
        this.$validator.errors.add({
          field: this.name,
          msg: `${this.$lang.messages.vee_the} ${this.name} ${this.$lang.messages.vee_requiredField}.`
        });
      }
    },
    setOption() {
      if (this.option) {
        let casesString = '';

        this.items.forEach(element => {
          element.children.forEach(child => {
            if (child.clicked) {
              casesString = `${casesString}${child.name}, `;
              this.newChildrenForInput.push(child);
            }
          })
        });

        // If input value ends with ", " remove it from the string
        casesString = casesString.substring(0, casesString.length - 2);

        this.search = casesString
      } else {
        this.items.forEach(element => {
          element.disabled = false;
          element.children.forEach(child => {
            child.clicked = false;
            child.disabled = false
          })
        })
      }
    },
  },
};
</script>
